import React from 'react';

/**
 * Inline <Redacted /> badge — a yellow "NAMES REDACTED" chip that replaces
 * specific buyer/marketplace names until the stealth-launch policy lifts.
 *
 * Usage:
 *   <Redacted count={4} hint="major UK reseller platforms" />
 *
 * Rationale: we want the legal prose to remain legally complete ("we reference
 * the following third parties ...") without revealing which ones we partner with
 * or compare against until the public reveal on launch.
 */
export default function Redacted({ count, hint }) {
  const label = count ? `${count} NAMES REDACTED` : 'NAMES REDACTED';
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded font-mono text-[11px] font-bold align-middle"
      style={{
        background: 'rgba(255, 215, 0, 0.15)',
        color: '#FFD700',
        border: '1px solid rgba(255, 215, 0, 0.45)',
      }}
      title={
        hint
          ? `Redacted until public launch: ${hint}`
          : 'Redacted until public launch and solicitor review'
      }
      data-testid="legal-redacted"
    >
      <span aria-hidden="true">⚠</span>
      <span>{label}</span>
    </span>
  );
}
